import { GetQuickFilterTextParams } from "ag-grid-community";
import { ReportsTableData } from "../../../../../../../../store/reports/utils/types/types";

export const reportsFrequencyQuickFilter = (
  params: GetQuickFilterTextParams<ReportsTableData>,
) => {
  return params.data.schedule?.frequency ?? "";
};
